'use client';

import { create } from 'zustand';

export type BlockReason = 'TRIAL_EXPIRED' | 'ACCOUNT_SUSPENDED';

interface AccountStatusState {
  blocked: boolean;
  reason: BlockReason | null;
  setBlocked: (reason: BlockReason) => void;
  clear: () => void;
}

export const useAccountStatusStore = create<AccountStatusState>((set) => ({
  blocked: false,
  reason: null,
  setBlocked: (reason) => set({ blocked: true, reason }),
  clear: () => set({ blocked: false, reason: null }),
}));
